import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import { MessageCard } from "../MessageCard";
import { DateDisplay } from "../DateDisplay";
import { FeatureToggle } from "../../models/FeatureToggles";
import { ValueDisplay } from "../ValueDisplay";
import { ListItemText } from "@material-ui/core";
import { Link } from "react-router-dom";
import { toFeatureToggleDetails } from "../../router/navigation";

interface FeatureTogglesListProps {
	featureToggles: FeatureToggle[];
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: theme.spacing(3),
	},
	list: {
		maxWidth: theme.breakpoints.values.md,
	},
	listItem: {
		boxShadow: theme.shadows[1],
		marginBottom: theme.spacing(2),
		paddingBottom: 12,
	},
	listSecondary: {
		marginTop: theme.spacing(0.5),
		fontSize: theme.typography.caption.fontSize,
	},
	details: {
		fontSize: theme.typography.body2.fontSize,
		marginTop: theme.spacing(1),
	},
}));

/**
 * Display feature toggles list
 * @param props
 */
export const FeatureTogglesList = (props: FeatureTogglesListProps) => {
	const classes = useStyles();

	return (
		<div data-testid="feature-toggles-list">
			{props.featureToggles && props.featureToggles.length > 0 ? (
				<div>
					<List className={classes.list}>
						{props.featureToggles.map((f) => (
							<ListItem key={f.featureToggleId} className={classes.listItem} data-testid="feature-toggle-list-item">
								<Grid container>
									<Grid item xs={12}>
										<ListItemText
											classes={{ secondary: classes.listSecondary }}
											primary={
												<Grid container justify="space-between">
													<Grid item>
														{
															<Link to={toFeatureToggleDetails(props.productId, f.featureToggleId)}>
																{f.displayName} ({f.name})
															</Link>
														}
													</Grid>
													<Grid item>
														<Typography variant="caption">
															updated on <DateDisplay date={f.updated} />
														</Typography>
													</Grid>
												</Grid>
											}
										/>
									</Grid>
									<Grid container className={classes.details}>
										<Grid item xs={12} sm={6} md={4}>
											<ValueDisplay label="Deployment ring" node={f.deploymentRing.name} />
										</Grid>

										<Grid item xs={12} sm={6} md={4}>
											<ValueDisplay label="Product tiers" node={f.productTierNames} />
										</Grid>
									</Grid>
								</Grid>
							</ListItem>
						))}
					</List>
				</div>
			) : (
				<MessageCard message="No feature toggles found." textAlign="left" />
			)}
		</div>
	);
};
